module.exports = __webpack_public_path__ + "img/fig04.c299ebff.jpg";